import { useTranslation } from 'react-i18next';
import DropdownMenu from '@src/components/DropdownMenu';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useLogOut } from '@src/hooks/useLogOut';

export default function UserAvatarDropdownMenu(): JSX.Element {
  const logOut = useLogOut();
  const { user } = useCurrentUser();
  const namePrefix = (user?.name || 'User').charAt(0);
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenu.Button className="flex rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
        <span className="sr-only">
          {t('app.open_user_menu_sr', 'Open user menu')}
        </span>
        <div className="h-8 w-8 rounded-full bg-yellow-400 text-center font-bold leading-8 text-white">
          {namePrefix}
        </div>
      </DropdownMenu.Button>
      <DropdownMenu.Items>
        <DropdownMenu.ButtonItem onClick={logOut}>
          {t('buttons.log_out', 'Log out')}
        </DropdownMenu.ButtonItem>
      </DropdownMenu.Items>
    </DropdownMenu>
  );
}
